import { ChangeDetectionStrategy, Component, computed, inject, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';
import { AppTranslateService } from '../../../core/services/translate.service';

@Component({
  selector: 'madero-language-selector',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  private readonly appTranslateService = inject(AppTranslateService);
  private readonly translateService = inject(TranslateService);

  currentLanguage = signal<string>('pt');
  languageChanged = output<string>();

  readonly languages = [
    { code: 'pt', flag: 'pt-br', label: 'PT' },
    { code: 'es', flag: 'es', label: 'ES' },
  ];

  readonly currentFlag = computed(() => {
    const lang = this.currentLanguage();
    return this.languages.find((l) => l.code === lang)?.flag || 'pt-br';
  });

  constructor() {
    const initialLang =
      this.translateService.currentLang ||
      (this.translateService as any).getDefaultLang?.() ||
      this.appTranslateService.getCurrentLanguage() ||
      'pt';

    this.currentLanguage.set(initialLang);
  }

  changeLanguage(lang: string): void {
    this.appTranslateService.changeLanguage(lang);
    this.currentLanguage.set(lang);
    this.languageChanged.emit(lang);
  }

  getFlagPath(flag: string): string {
    return `assets/flags/${flag}.svg`;
  }
}
